module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAA+UlEQVQoU32QP0rGQBDFZ3Y3zWoREDyArY0kWbLyVZteETyBx/DrxSvYeQArwSaFbLUkmw18jbUXEDuTRpORFZT4B1837/Eb5g2GEI7neXZlWT7DP/Le7zDGVui9vwKAA855VRTF+BdT1/VWmqb3ALDBvu+TaZruAOB1HMcTY8zbErLWCinlLQBwzvkRxtBauy2ltET0oLU+WwJd110DwP4wDJUx5uUDiHLO7QohHBHdaK3X0Wvb9hIRT5MkWWVZ9hS9LyAOIYS9+ADG2AURMSI6j0WVUo+fi78B0WyaJuOcx4KAiJVSarM88RcQQ+/9oRCC8jxvf37tHTgFWRMNuTvJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 3Uj3
// module chunks = 1